const SCENE_NODE_TYPES = new Set(["first-scene-node", "node-with-toolbar"]);

export function getScenarioSceneNodes(nodes = []) {
  const groupIds = new Set(
    nodes
      .filter((node) => node?.type === "group")
      .map((node) => String(node.id)),
  );

  return nodes.filter((node) => {
    if (!node || node.type === "group" || node.type === "input") return false;
    if (SCENE_NODE_TYPES.has(node.type) || String(node.id) === "1") return true;

    // Older saved scenes may not have retained their React Flow type. Scene
    // nodes are children of a group, while buttons are explicitly type "input".
    const parentId = node.parentId ?? node.parentNode;
    return parentId != null && groupIds.has(String(parentId));
  });
}

export function getScenarioSceneButtons(scene, nodes = [], edges = []) {
  if (!scene) return [];

  const sceneId = String(scene.id);
  const legacyButtonIds = new Set(
    edges
      .filter((edge) => String(edge.source) === sceneId)
      .map((edge) => String(edge.target)),
  );
  const buttonNodes = nodes.filter((node) => {
    if (node?.type !== "input") return false;

    const buttonId = String(node.id);
    const parentId = node.parentId ?? node.parentNode;
    return (
      String(parentId ?? "") === `${sceneId}-group` ||
      buttonId.startsWith(`${sceneId}-`) ||
      legacyButtonIds.has(buttonId)
    );
  });

  return buttonNodes.map((buttonNode) => {
    const buttonId = String(buttonNode.id);
    const sceneEdge = edges.find((edge) => String(edge.source) === buttonId);

    const nextSceneId = sceneEdge ? String(sceneEdge.target) : null;
    const nextScene = nextSceneId
      ? nodes.find((node) => String(node.id) === nextSceneId)
      : null;

    return {
      id: buttonNode.id,
      buttonId: buttonNode.id,
      label: buttonNode.data?.label ?? "",
      buttonPosiiton: buttonNode.data?.buttonPosiiton,
      targetSceneId: nextScene ? nextScene.id : null,
      targetSceneLabel: nextScene?.data?.label ?? "Новая сцена",
    };
  });
}
